__turbopack_context__.v({
  "className": "arminfont_7b692cab-module__K3jlaq__className",
  "variable": "arminfont_7b692cab-module__K3jlaq__variable",
});
